import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-657eb232"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel, useDebounceFn } from '@vueuse/core';
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { updateClinicShop, addClinicShop } from '@/api/clinicShop';
export default {
  __name: 'addClinicShopDialog',
  props: {
    // 是否回显数据
    model: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;

    // 表单数据
    const formData = ref({
      shopId: '',
      // 商城编号
      clinicId: '',
      // 诊所id
      clinicName: '',
      // 门诊名称
      path: '' // 微信公众号路径path
    });
    const resetForm = () => {
      formData.value = {
        shopId: '',
        // 商城编号
        clinicId: '',
        // 诊所id
        clinicName: '',
        // 门诊名称
        path: '' // 微信公众号路径path
      };
    };
    watch(() => props.model, val => {
      if (val) {
        formData.value = {
          id: val.id,
          ...JSON.parse(JSON.stringify(val))
        };
      } else {
        resetForm();
      }
    }, {
      deep: true,
      immediate: true
    });
    const emits = __emit;
    const isVisible = useVModel(props);
    const rules = ref({
      shopId: [{
        required: true,
        message: '不能为空',
        trigger: 'blur'
      }],
      clinicId: [{
        required: true,
        message: '不能为空',
        trigger: 'blur'
      }],
      clinicName: [{
        required: true,
        message: '不能为空',
        trigger: 'blur'
      }],
      path: [{
        required: true,
        message: '不能为空',
        trigger: 'blur'
      }]
    });

    // 表单元素
    const formEl = ref(null);
    /**
     * 新增事件
     */
    const addNewsGmHandler = useDebounceFn(async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          try {
            if (!props.model) {
              await addClinicShop(formData.value);
            } else {
              await updateClinicShop(formData.value);
            }
            emits('refreshData');
            ElMessage({
              type: 'success',
              message: props.model ? '修改成功' : '添加成功'
            });
          } catch (error) {
            console.log(error);
          } finally {
            isVisible.value = false;
          }
        } else {
          ElMessage({
            type: 'error',
            message: '验证失败'
          });
        }
      });
    }, 300);
    const closed = () => {
      formEl.value.resetFields();
      resetForm();
      if (props.model) {
        emits('clearModel');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改应用' : '新增应用',
        width: "50%",
        onClosed: closed,
        "close-on-click-modal": false,
        class: "dialog-class"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(addNewsGmHandler)
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        }, 8, ["onClick"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          rules: rules.value,
          style: {
            "max-width": "90%"
          },
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "商城编号",
            prop: "shopId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.shopId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.shopId = $event),
              placeholder: "请输入商城编号"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "诊所id",
            prop: "clinicId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.clinicId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.clinicId = $event),
              placeholder: "请输入诊所id"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "门诊名称",
            prop: "clinicName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.clinicName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.clinicName = $event),
              placeholder: "请输入门诊名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "微信公众号路径",
            prop: "path"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.path,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.path = $event),
              placeholder: "请输入微信公众号路径"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};